/**
 * 本サービスの利用目的カテゴリー
 */
export const ServicePurposeCode = {
  BUSINESS_SALE: 'business_sale',
  BUSINESS_ACQUISITION: 'business_acquisition',
  SEEKING_INVESTMENT: 'seeking_investment',
  INTERESTED_IN_INVESTMENT: 'interested_in_investment',
  CO_CREATION_LAB: 'co_creation_lab',
  JOINT_VENTURE: 'joint_venture',
  BUSINESS_PARTNER: 'business_partner',
  MARKET_TEST: 'market_test',
  NEW_CUSTOMER_EXPANSION: 'new_customer_expansion',
  NETWORKING: 'networking',
  PRESENTATION_OPPORTUNITY: 'presentation_opportunity',
  TECH_CONTEST: 'tech_contest',
  IDEA_CONTEST: 'idea_contest',
  LIMITED_PROJECT: 'limited_project',
  SALES_CHANNEL: 'sales_channel',
  PRODUCT_IMPROVEMENT: 'product_improvement',
  EXTERNAL_RESOURCES: 'external_resources',
  TECH_SHARING: 'tech_sharing',
  JOINT_DEVELOPMENT: 'joint_development',
  RESEARCH_COLLABORATION: 'research_collaboration',
} as const

export type ServicePurposeCodeValue =
  (typeof ServicePurposeCode)[keyof typeof ServicePurposeCode]

export const ServicePurposeLabel: { [key: string]: string } = {
  [ServicePurposeCode.BUSINESS_SALE]: '事業売却を検討している',
  [ServicePurposeCode.BUSINESS_ACQUISITION]: '他社の事業・会社を買収したい',
  [ServicePurposeCode.SEEKING_INVESTMENT]: '投資・資金援助を求めている',
  [ServicePurposeCode.INTERESTED_IN_INVESTMENT]: '出資・投資に関心がある',
  [ServicePurposeCode.CO_CREATION_LAB]: '共創ラボの立ち上げ希望',
  [ServicePurposeCode.JOINT_VENTURE]: '合弁会社の設立を検討中',
  [ServicePurposeCode.BUSINESS_PARTNER]: '事業パートナーを探している',
  [ServicePurposeCode.MARKET_TEST]: '市場反応を試す場を求めている',
  [ServicePurposeCode.NEW_CUSTOMER_EXPANSION]: '新しい顧客・領域への展開を検討している',
  [ServicePurposeCode.NETWORKING]: '人脈形成・情報交換をしたい',
  [ServicePurposeCode.PRESENTATION_OPPORTUNITY]: 'プレゼン機会の場を持ちたい／開催したい',
  [ServicePurposeCode.TECH_CONTEST]: '技術系アイデアコンテストを開催したい／参加したい',
  [ServicePurposeCode.IDEA_CONTEST]: '発想コンテストを通じた課題解決をしたい',
  [ServicePurposeCode.LIMITED_PROJECT]: '限定プロジェクト・イベントでのコラボ希望',
  [ServicePurposeCode.SALES_CHANNEL]: '販売チャネルを広げたい',
  [ServicePurposeCode.PRODUCT_IMPROVEMENT]: 'プロダクトやシステムの改善を模索している',
  [ServicePurposeCode.EXTERNAL_RESOURCES]: '技術やアイデアなどの外部資源を探している',
  [ServicePurposeCode.TECH_SHARING]: '自社の技術や特許を共有・活用したい',
  [ServicePurposeCode.JOINT_DEVELOPMENT]: '製品の共同開発パートナーを求めている',
  [ServicePurposeCode.RESEARCH_COLLABORATION]: '研究分野での連携を模索している',
}

export const ServicePurposeValues = Object.entries(ServicePurposeLabel).map(
  ([code, value]) => ({
    code,
    value,
  })
)
